import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbCalendar, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription, zip } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { CustomerData } from 'src/app/models/customer.model';
import { Statuses } from 'src/app/models/kn-br-draft-order.model';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { KnBrDateHelper } from 'src/app/shared/kn-br-date.helper';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { KnBrInvoiceService } from 'src/app/store/kn-br-invoice/kn-br-invoice.service';
import { INVOICE_PAGESIZE } from 'src/constants/pagination.constant';
import { isEqual } from 'lodash';
import { NgSelectComponent, NgOptionTemplateDirective, NgMultiLabelTemplateDirective } from '@ng-select/ng-select';
import { AsyncPipe, SlicePipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-kn-br-invoice-list-search',
    templateUrl: './kn-br-invoice-list-search.component.html',
    styleUrls: ['./kn-br-invoice-list-search.component.scss'],
    imports: [ReactiveFormsModule, NgSelectComponent, NgOptionTemplateDirective, NgMultiLabelTemplateDirective, NgbInputDatepicker, AsyncPipe, SlicePipe, TranslatePipe]
})
export class KnBrInvoiceListSearchComponent implements OnInit, OnDestroy {
  invoiceSearchForm: FormGroup;
  invoiceStatusList$: Observable<Statuses[]> = this.knBrCommonService.loadInvoiceStatusList$();
  invoiceFilterByList$: Observable<any[]> = this.knBrCommonService.loadInvoiceFilterByList$();
  customersDataList$: Observable<any> = this.knBrCommonService.loadCustomersData$();
  invoiceDocumentTypeList$: Observable<Statuses[]> = this.knBrCommonService.loadInvoiceDocumentTypeList$();
  customerContextData$: Observable<CustomerData> = this.knBrCustomerContextService.get$;
  brandList$: Observable<any[]> = this.knBrCommonService.loadActiveSalse$();
  status$: Observable<Statuses[]> = this.knBrCommonService.loadQuoteStatuses$();
  documentTypeList: Statuses[] = [];
  filterByList: Statuses[] = [];
  selectedCustomer: CustomerData;
  currentPage = 0;
  customerNumber = '';
  objectKeys = Object.keys;
  brandList = [];
  subscription = new Subscription();
  todayDate = () => {
    const today = new Date();
    return ({ year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() });
  };
  maxStartDate = () => this.todayDate();
  maxEndDate = () => this.todayDate();
  fromDate: any;
  toDate: any;
  // customersDataList = [];

  isSearchDisabled$: Observable<boolean> = this.knBrInvoiceService.isSearchDisabled$;
  pCustomersId = [];
  pBrandName = [];
  pStatus = [];
  pDocumentType = [];
  state$: Observable<unknown>;
  retrievalPending = true;
  hasContext = false;
  combinedCallSubscription: Subscription;
  customerDataList = [];

  constructor(
    private fb: FormBuilder,
    private knBrInvoiceService: KnBrInvoiceService,
    protected knBrCommonService: KnBrCommonService,
    public ngbCalendar: NgbCalendar,
    private knBrDateHelper: KnBrDateHelper,
    private knBrCustomerContextService: KnBrCustomerContextService,
    protected activatedRoute: ActivatedRoute,
    protected cd: ChangeDetectorRef
  ) {
    this.knBrCommonService.getActiveSalse();
  }

  ngOnInit(): void {
    this.state$ = this.activatedRoute.paramMap.pipe(map(() => window.history.state));
    this.subscription = this.customerContextData$.subscribe((value) => {
      if (value) {
        this.hasContext = true;
        this.selectedCustomer = value;
        this.customerNumber = this.selectedCustomer.customerNumber ? this.selectedCustomer.customerNumber : null;
        this.knBrInvoiceService.isSearchInitiated$.next(true);
      } else {
        this.getCustomers();
      }
      this.knBrCommonService.getInvoiceStatusList();
      this.knBrCommonService.getInvoiceFilterByList();
      this.knBrCommonService.getInvoiceDocumentTypeList();
      this.knBrInvoiceService.setInvoiceInit(true);
      this.initForm();
    });

    this.invoiceFilterByList$.subscribe((filterByList) => {
      if (filterByList && filterByList.length > 0) {
        const selectedFilter = filterByList.find((item) => item.Key === 'DOCUMENT_TYPE');
        if (selectedFilter) {
          this.invoiceSearchForm.patchValue({ filterBy: selectedFilter.Key });
        }
      }
    });
    this.subscription = this.brandList$.subscribe(res => {
      if (res && this.brandList.length === 0) {
        res.forEach(item => this.brandList.push(item.value));
        this.invoiceSearchForm.patchValue({
          brandList: this.brandList.join(','),
        });
        this.submitForm();
      }
    });
  }

  getCustomers() {
    this.subscription = this.knBrCommonService.customersData$.subscribe(res => {
      if (res === null) {
        this.knBrCommonService.getCustomersData();
      }
    })
  };

  initForm() {
    const persistedData = JSON.parse(sessionStorage.getItem("invoiceSearch"));
    let flagValue = false;
    this.state$.subscribe((data:any) => {
      if(data && data.displayPersistedValues) {
        flagValue = true;
      } else {
        flagValue = false;
      }
    })
    this.invoiceSearchForm = this.fb.group({
      customersId: [{
        value: this.selectedCustomer && this.selectedCustomer?.customerNumber ? this.knBrCommonService.combineCustomerData(this.selectedCustomer) : null,
        disabled: this.selectedCustomer ? true : false
      }],
      purchaseOrderNumber: (flagValue && persistedData?.purchaseOrderNumber) ? persistedData.purchaseOrderNumber : null,
      documentNo: (flagValue && persistedData?.documentNo) ? persistedData.documentNo : null,
      status: null,
      filterBy: null,
      documentType: null,
      startDate: null,
      endDate: null,
      fromOpenAmount: null,
      toOpenAmount: null,
      fromOriginalAmount: null,
      toOriginalAmount: null,
      currentPage: this.currentPage,
      brandName: null,
      brandList: [this.brandList],
      pageSize: INVOICE_PAGESIZE,
      jobName: (flagValue && persistedData?.jobName) ? persistedData.jobName : null,
      _startDate: (flagValue && persistedData?.startDate) ? this.knBrCommonService.formatDate(this.knBrDateHelper.getDate(persistedData.startDate)) : null,
      _endDate: (flagValue && persistedData?.endDate) ? this.knBrCommonService.formatDate(this.knBrDateHelper.getDate(persistedData.endDate)) : null
    });
    this.setDateValidators();

    this.state$.subscribe((data:any) => {
      if (data && data.displayPersistedValues && this.retrievalPending) {
        if (persistedData) {
          const sessionStorageCusNo = sessionStorage.getItem("sscustomerNumber") === "undefined" ? undefined : sessionStorage.getItem("sscustomerNumber") ;
          if (this.selectedCustomer?.customerNumber != sessionStorageCusNo && this.retrievalPending) {
            this.retrievalPending = false;
            this.combinedCallSubscription = zip(this.status$).subscribe((res:any)=> {
              const combinedData = {
                statusData: res[0],
                bresp: res[1],
              }
              const { statusData, bresp } = combinedData;
                if (persistedData.status) {
                  persistedData.status = persistedData.status.filter(eachStatus => this.containsObject(eachStatus, statusData));
                  this.pStatus = persistedData.status;
                }
                if (persistedData.brandName) {
                  persistedData.brandName = persistedData.brandName.filter((eachbrnd) => this.containsObject(eachbrnd, bresp.brand) )
                  this.pBrandName = persistedData.brandName || [];
                }
                if (persistedData.documentType) {
                  persistedData.documentType = persistedData.documentType.filter((eachbrnd) => this.containsObject(eachbrnd, bresp.brand) )
                  this.pBrandName = persistedData.documentType || [];
                }
                this.submitForm("persist")
              })
          } else if(this.retrievalPending) {
            this.retrievalPending = false
            this.brandList = persistedData.brandList;
            this.pBrandName = persistedData.brandName || [];
            this.pStatus = persistedData.status || [];
            this.pDocumentType = persistedData.documentType || [];
            this.pCustomersId = persistedData.customersId || [];
            this.submitForm("newpersist")
          } else {
            this.submitForm()
          }
        }
      } else {
        this.submitForm();
      }
    })
  }

  setDateValidators() {
    const startDate = this.invoiceSearchForm.get('_startDate');
    const enddate = this.invoiceSearchForm.get('_endDate');

    startDate.valueChanges.pipe(distinctUntilChanged()).subscribe(fromDate => {
      if (fromDate && enddate.value === null) {
        enddate.setValidators([Validators.required]);
      } else {
        enddate.setValidators(null);
      }
      enddate.updateValueAndValidity();

      if (enddate.value && startDate.value) {
        const { year: y2, month: m2, day: d2 } = enddate.value;
        const e = new Date(y2, m2 - 1, d2);

        const { year: y1, month: m1, day: d1 } = startDate.value;
        const s = new Date(y1, m1 - 1, d1);

        if (s > e) {
          enddate.setValue(null)
        }
      }
    });
    enddate.valueChanges.pipe(distinctUntilChanged()).subscribe(toDate => {
      if (toDate) {
        startDate.setValidators([Validators.required]);
      } else {
        startDate.setValidators(null);
      }
      startDate.updateValueAndValidity();
    });
  }

  submitForm(shouldRetain?, searchInitiated?) {
    if (this.invoiceSearchForm.valid) {
      this.invoiceSearchForm.patchValue({
        startDate: this.knBrDateHelper.formatDate(this.invoiceSearchForm.controls._startDate.value),
        endDate: this.knBrDateHelper.formatDate(this.invoiceSearchForm.controls._endDate.value)
      })
    }
    const { ...payload } = this.invoiceSearchForm.getRawValue();
    const updatedPayload = {...payload};
    const updatedSessionStorage = {...payload};
    if (shouldRetain) {
      updatedSessionStorage.status = this.pStatus;
      updatedSessionStorage.brandName = this.pBrandName;
      updatedSessionStorage.customersId = this.pCustomersId;
      updatedSessionStorage.documentType = this.pDocumentType;
      updatedPayload.brandList = this.brandList;
      updatedPayload.status = (this.pStatus && this.pStatus.length) ? this.pStatus.map(eachStatus => eachStatus.Key).join(",") : '';
      updatedPayload.customersId = (this.pCustomersId && this.pCustomersId.length) ? this.pCustomersId.map(eachStatus => eachStatus.Key).join(",") : '';
      updatedPayload.brandName = (this.pBrandName && this.pBrandName.length) ? this.pBrandName.map(eachbrandName => eachbrandName.value).join(",") : '';
      updatedPayload.documentType = (this.pDocumentType && this.pDocumentType.length) ? this.pDocumentType.map(eachDocumentType => eachDocumentType.Key).join(",") : ''
    } else {
      if (this.selectedCustomer) {
        updatedPayload.customersId = this.selectedCustomer?.customerNumber;
        const searchCriteria = { customersId: updatedPayload.customersId };
        this.loadDuesAmount(searchCriteria);
      } else if (updatedPayload && updatedPayload.customersId?.length > 0) {
        updatedPayload.customersId = updatedPayload.customersId.map(eachStatus => eachStatus.Key).join(",");
        this.loadDuesAmount({customersId: updatedPayload.customersId});
      }
      updatedPayload.pageSize = payload.pageSize ? payload.pageSize : 50;
      updatedPayload.status = (payload.status && payload.status.length) ? payload.status.map(eachStatus => eachStatus.Key).join(",") : '';
      updatedPayload.brandName = (payload.brandName && payload.brandName.length) ? payload.brandName?.map(eachbrand => eachbrand.value).join(",") : '';
      updatedPayload.documentType = (payload.documentType &&  payload.documentType.length) ? payload.documentType.map(eachDocumentType => eachDocumentType.Key).join(",") : '';
    }
    window.sessionStorage.setItem("sscustomerNumber", this.selectedCustomer?.customerNumber);
    window.sessionStorage.setItem("invoiceSearch",JSON.stringify(updatedSessionStorage));
    this.knBrInvoiceService.isSearchInitiated$.next(searchInitiated);
    this.knBrInvoiceService.search(updatedPayload);
    this.knBrInvoiceService.setInvoiceInit(false);
  }

  loadDuesAmount(searchCriteria) {
    this.knBrInvoiceService.loadDues(searchCriteria);
  };

  containsObject(obj, list) {
    var i;
    for (i = 0; i < list?.length; i++) {
      if (isEqual(list[i], obj)) {
        return true;
      }
    }
    return false;
  }

  get filterBySelectedValue(): AbstractControl {
    return this.invoiceSearchForm.get('filterBy');
  }


  resetForm() {
    this.invoiceSearchForm.reset();
    sessionStorage.removeItem('invoiceSearch');
    this.knBrInvoiceService.isSearchInitiated$.next(false);
    this.invoiceSearchForm.patchValue({
      brandList: this.brandList
    });
    this.knBrCommonService.fromDate = null;
    this.knBrCommonService.toDate = null;
    this.initForm();
    this.clearDateInfo();
  }

  onDateChange(value, param?) {
    this.knBrCommonService.onDateChange(value, param);
  }

  clearDateInfo() {
    this.knBrCommonService.clearDateInfo();
  }

  ngOnDestroy() {
    if (this.combinedCallSubscription) {
      this.combinedCallSubscription.unsubscribe();
    }
    this.subscription?.unsubscribe();
    this.clearDateInfo();
    this.knBrInvoiceService.isSearchInitiated$.next(false);
  }
}
